import { UseCaseInteractor } from '../../../kernel/use-case'
import { bodyCreateStop, MultistopRepository } from '../domain/multistop.repository'

export const postMultistopUseCase: UseCaseInteractor<
  [multistopRepository: MultistopRepository],
  [jobUuid: string, body: bodyCreateStop],
  void
> = (multistopRepository) => async (jobUuid, body) => multistopRepository.create(jobUuid, body)
